<script setup>
import { computed, ref, watch } from "vue";
import Textarea from "primevue/textarea";
import { storeToRefs } from "pinia";
import { useCriarQuestoesStore } from "@/store/criarQuestoes";
const store = useCriarQuestoesStore();
const { textoDigitado, textoDigitadoComparar, menssagemErroInline, opcoesValidas, modeloQuestaoSelecionado } = storeToRefs(store);



const mensagemErro = ref("Insira um texto");
const mensagemErroComparar = ref("Insira um texto");

watch(textoDigitado, () => {
    if(textoDigitado.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto) {
        opcoesValidas.value = false;
        mensagemErro.value = "O número máximo de caracteres permitidos é de " + modeloQuestaoSelecionado.value.tamanho_maximo_texto + ".";
    }else if(textoDigitado.value.trim().length < 1) {
        opcoesValidas.value = false
        mensagemErro.value = "Preencha o campo";
    }else{
        opcoesValidas.value = true;

    }
})

watch(textoDigitadoComparar, () => {
    if (textoDigitadoComparar.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto) {
        opcoesValidas.value = false;
        mensagemErroComparar.value = "O número máximo de caracteres permitidos é de " + modeloQuestaoSelecionado.value.tamanho_maximo_texto + ".";
    } else if (textoDigitadoComparar.value.trim().length < 1) {
        opcoesValidas.value = false
        mensagemErroComparar.value = "Preencha o campo";
    } else {
        opcoesValidas.value = true;
    }
})

const textArea2Invalido = computed(() => {
    if(textoDigitadoComparar.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto) {
        return true;
    }

    if(textoDigitadoComparar.value.trim().length < 1) {
        return true
    }

    return false
})

const textArea1Invalido = computed(() => {
    if(textoDigitado.value.trim().length > modeloQuestaoSelecionado.value.tamanho_maximo_texto) {
        return true;
    }

    if(textoDigitado.value.trim().length < 1) {
        return true
    }

    return false
})

</script>
<template>
    <div class="flex flex-column gap-4">

        <div class="flex flex-column gap-1">
            <label class="flex justify-content-between">
                <div>{{ modeloQuestaoSelecionado.numeros_textos == 1 ? 'Texto' : 'Texto I' }}</div>
                <div class="text-xs text-gray-500"
                    :class="{ 'text-red-500': textoDigitado.length > modeloQuestaoSelecionado.tamanho_maximo_texto }">
                    {{textoDigitado.length}}/{{ modeloQuestaoSelecionado.tamanho_maximo_texto}}
                </div>
            </label>
            <Textarea rows="5" v-model="textoDigitado" :invalid="menssagemErroInline && textArea1Invalido" />
            <label v-if="menssagemErroInline && textoDigitado.length < 1" class="text-red-500 text-sm">
                Digite um texto
            </label>
            <label v-if="textoDigitado.length > modeloQuestaoSelecionado.tamanho_maximo_texto" class="text-red-500 text-sm">
                Seu texto tem {{ textoDigitado.length }} caracteres. O número máximo é {{ modeloQuestaoSelecionado.tamanho_maximo_texto }}
            </label>
        </div>


        <div class="flex flex-column gap-1" v-if="modeloQuestaoSelecionado.numeros_textos == 2">
            <label class="flex justify-content-between">
                <div>Texto II</div>
                <div class="text-xs text-gray-500"
                    :class="{ 'text-red-500': textoDigitadoComparar.length > modeloQuestaoSelecionado.tamanho_maximo_texto }">
                    {{ textoDigitadoComparar.length }}/{{ modeloQuestaoSelecionado.tamanho_maximo_texto }}
                </div>
            </label>
            <Textarea rows="5" v-model="textoDigitadoComparar" :invalid="menssagemErroInline && textArea2Invalido"/>
            <label v-if="textoDigitadoComparar.length > modeloQuestaoSelecionado.tamanho_maximo_texto"
                class="text-red-500 text-sm">
                Seu texto tem {{ textoDigitadoComparar.length }} caracteres. O número máximo é {{
                modeloQuestaoSelecionado.tamanho_maximo_texto }}
            </label>
            <label v-if="textoDigitadoComparar.length === 0 && menssagemErroInline"
                class="text-red-500 text-sm">
                Digite um texto
            </label>
        </div>
    </div>

</template>